import { render } from "./App.vue?vue&type=template&id=7798a42a&bindings={\"phrase\":\"setup\",\"service\":\"setup\",\"password\":\"setup\",\"copied\":\"setup\",\"generate\":\"setup\",\"copy\":\"setup\"}"
import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./App.vue?vue&type=style&index=0&lang=postcss"
script.render = render

export default script